import React from 'react'

import { tableColumnDefaultOption } from 'app/config'

export const NO_ROLE = ''

/**
 * The "Role" column shared by the Admin and Teacher screens (a role can only be
 * held by an admin or a teacher).
 *
 * Keyed on `user.role.uuid`, not `user.role`: BaseForm seeds a <select> from
 * get(formData, column.name), so the column has to point at a scalar. Pointing
 * it at the nested role object would hand the Select an object and it would
 * render blank.
 *
 * The role list is fetched by the page and passed in — BaseForm's `select`
 * widget takes a plain {value: label} map and has no async support.
 */
export const buildRoleColumn = (roles) => {
  const labelByUuid = roles.reduce(
    (acc, role) => ({ ...acc, [role.uuid]: role.name }),
    { [NO_ROLE]: 'No role — sees everything' }
  )

  return {
    ...tableColumnDefaultOption,
    name: 'user.role.uuid',
    label: 'Role',
    widget: 'select',
    // A role is not required: null is the normal state, and means "sees
    // everything" until somebody is actually given one.
    optional: true,
    valueLabelMappings: labelByUuid,
    options: {
      ...tableColumnDefaultOption.options,
      filter: false,
      sort: false,
      customBodyRender: (value) => (
        <span>{labelByUuid[value || NO_ROLE] || '—'}</span>
      )
    }
  }
}
